import React, { useContext, useEffect, useRef, useState } from 'react';
import { peicarLogoSVG } from '../../Assets/Images';
import { headerCSS } from './Header.css';
import { BsSearch } from 'react-icons/bs';
import { RxHamburgerMenu } from 'react-icons/rx';
import { SideMenu } from './SideMenu/SideMenu';
import { scrollToBottom, scrollToElement } from '../../Views/Landing/functions';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../Context/AuthContext';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { url } from '../../env';
import { Loader } from '../Loader/Loader';
import ProfilePopover from './ProfilePopover';
import AlertsBell from '../../Views/Admin/Alerts/AlertsBell';


const dashboardPathFor = (typeUser) => {
    const t = String(typeUser ?? '');
    if (t === '1') return '/admin';
    if (t === '3') return '/admin-trim';
    if (t === '2' || t === '4') return '/vendedor';
    return '/';
};

const ROLE_LABELS = {
    '1': 'Admin Pei',
    '2': 'Vendedor Pei',
    '3': 'Admin Trim',
    '4': 'Vendedor Trim',
};

const getInitials = (name = '') =>
    name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase())
        .join('') || '?';

const profileHeaderTemplate = (user) => () => (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        padding: '0.85rem 1rem',
        borderBottom: '1px solid #e2e8f0',
        background: '#f8fafc',
    }}>
        <div style={{
            width: 38,
            height: 38,
            borderRadius: '50%',
            background: '#34b9e0',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            fontSize: '0.85rem',
            flexShrink: 0,
        }}>
            {getInitials(user?.name)}
        </div>
        <div style={{ minWidth: 0, flex: 1 }}>
            <div style={{
                fontSize: '0.85rem',
                fontWeight: 700,
                color: '#0f172a',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}>
                {user?.name || 'Sin nombre'}
            </div>
            <div style={{
                fontSize: '0.72rem',
                color: '#64748b',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}>
                {user?.email || '—'}
            </div>
            {user?.type_user != null && ROLE_LABELS[String(user.type_user)] && (
                <div style={{
                    marginTop: 4,
                    fontSize: '0.65rem',
                    color: '#1d4ed8',
                    background: '#dbeafe',
                    padding: '1px 8px',
                    borderRadius: 999,
                    display: 'inline-block',
                    fontWeight: 600,
                }}>
                    {ROLE_LABELS[String(user.type_user)]}
                </div>
            )}
        </div>
    </div>
);

const getItems = (navigate, logout, setLoading, user) => [
    {
        template: profileHeaderTemplate(user),
    },
    {
        label: 'Cuenta',
        items: [
            {
                label: 'Mi panel',
                icon: 'pi pi-th-large',
                command: () => {
                    navigate(dashboardPathFor(user?.type_user));
                }
            },
            {
                label: 'Cerrar sesion',
                icon: 'pi pi-sign-out',
                command: async () => {
                    setLoading(true);
                    const token = localStorage.getItem('token');
                    await fetch(`${url}/logout`, {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });

                    logout();
                    setLoading(false);
                    navigate('/login');
                }
            }
        ]
    }
];



function Header() {

    const { authInfo, logout } = useContext(AuthContext);
    const [showSidebar, setShowSidebar] = useState(false);
    const navigate = useNavigate();
    const menuLeft = useRef(null);
    const [loading, setLoading] = useState(false);

    const items = getItems(navigate, logout, setLoading, authInfo.user);
    const isInternalUser = authInfo.isAuth && ['1', '2', '3', '4'].includes(String(authInfo.user?.type_user ?? ''));
    const isAdminPei = authInfo.isAuth && String(authInfo.user?.type_user ?? '') === '1';
    const [profileOpen, setProfileOpen] = useState(false);

    const handleGoDashboard = () => {
        navigate(dashboardPathFor(authInfo.user?.type_user));
    };

    const handleLogout = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            await fetch(`${url}/logout`, {
                method: 'POST',
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
            });
        } catch (e) {
            // best-effort
        }
        logout();
        setLoading(false);
        navigate('/login');
    };

    function responsiveScrollToElement(id) {
        scrollToElement(id);
        setShowSidebar(false);
    }

    const handleLogin = () => {
        navigate('/login');
    }

    const handleClick = (event) => {
        // console.log('click', event);
    }

    return (
        <>
            {loading && <Loader />}
            <div css={headerCSS()}>
                <div className="Container">
                    <div className="Left GridItem" onClick={() => navigate("/")}>
                        <img src={peicarLogoSVG} />
                        <span>La llave a tu movilidad</span>
                    </div>

                    {/* <div className="Center GridItem">
                    <div className="SearchContainer">
                        <input type="text" className='SearchInput' placeholder='Buscar' />
                        <BsSearch className='Icon' />
                    </div>
                </div> */}

                    <div className="Right GridItem">
                        <div className="Nav">
                            <span onClick={() => scrollToElement("secondSectionID")}>
                                Producto
                            </span>

                            <span onClick={() => scrollToElement("fourthSectionID")}>
                                Con&oacute;cenos
                            </span>

                            <span onClick={() => scrollToElement("procesoPeicarID")}>
                                Proceso
                            </span>

                            <span onClick={scrollToBottom}>
                                Hablemos
                            </span>
                            {isInternalUser ?
                                <>
                                    {isAdminPei && <AlertsBell />}
                                    <span style={{ position: 'relative', display: 'inline-flex' }}>
                                        <Avatar
                                            icon="pi pi-user"
                                            style={{ backgroundColor: '#34b9e0', color: '#ffffff', width: '32px', height: '32px', cursor: 'pointer' }}
                                            shape="circle"
                                            onClick={() => setProfileOpen((p) => !p)}
                                            aria-haspopup
                                            aria-expanded={profileOpen}
                                        />
                                        <ProfilePopover
                                            open={profileOpen}
                                            onClose={() => setProfileOpen(false)}
                                            user={authInfo.user}
                                            onGoDashboard={handleGoDashboard}
                                            onLogout={handleLogout}
                                        />
                                    </span>
                                </>
                                :
                                <span onClick={handleLogin}>
                                    Iniciar sesi&oacute;n
                                </span>
                            }
                        </div>

                        <div className="SideMenuContainer">
                            <RxHamburgerMenu
                                className='Icon'
                                onClick={() => setShowSidebar(true)}
                            />
                            <SideMenu
                                visible={showSidebar}
                                setVisible={setShowSidebar}
                            >

                                <nav className='MobileNav'>

                                    {isInternalUser ?
                                        <>
                                            {isAdminPei && <AlertsBell />}
                                            <span style={{ position: 'relative', display: 'inline-flex' }}>
                                                <Avatar
                                                    icon="pi pi-user"
                                                    size='large'
                                                    style={{ backgroundColor: '#34b9e0', color: '#ffffff', cursor: 'pointer' }}
                                                    shape="circle"
                                                    onClick={() => setProfileOpen((p) => !p)}
                                                    aria-haspopup
                                                    aria-expanded={profileOpen}
                                                />
                                                <ProfilePopover
                                                    open={profileOpen}
                                                    onClose={() => setProfileOpen(false)}
                                                    user={authInfo.user}
                                                    onGoDashboard={handleGoDashboard}
                                                    onLogout={handleLogout}
                                                />
                                            </span>
                                        </>
                                        :
                                        <span onClick={handleLogin}>
                                            Iniciar sesi&oacute;n
                                        </span>
                                    }

                                    <span onClick={() => responsiveScrollToElement("secondSectionID")}>
                                        Producto
                                    </span>

                                    <span onClick={() => responsiveScrollToElement("fourthSectionID")}>
                                        Con&oacute;cenos
                                    </span>

                                    <span onClick={() => responsiveScrollToElement("procesoPeicarID")}>
                                        Proceso
                                    </span>

                                    <span>Hablemos</span>


                                </nav>
                            </SideMenu>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export { Header };